import { httpClient } from "../../../shared/api/httpClient";
import type { PaginatedResponse } from "../../../shared/api/pagination";
import type {
  ShodanOrderLineResponse,
  ShodanOrderResponse,
} from "../model/types";

export const fetchShodanOrders = async (
  page = 1,
  pageSize = 20,
  search?: string,
  status?: string,
): Promise<PaginatedResponse<ShodanOrderResponse>> => {
  const response = await httpClient.get<PaginatedResponse<ShodanOrderResponse>>(
    "/shodan-orders",
    {
      params: {
        page,
        page_size: pageSize,
        search: search?.trim() || undefined,
        status: status || undefined,
      },
    },
  );
  return response.data;
};

export const fetchShodanOrderDetail = async (
  customerCode: string,
  branchCode: string,
  orderNumber: string,
  deliveryDate: string,
): Promise<ShodanOrderLineResponse[]> => {
  const response = await httpClient.get<ShodanOrderLineResponse[]>(
    "/shodan-orders/detail",
    {
      params: {
        customer_code: customerCode,
        branch_code: branchCode,
        order_number: orderNumber,
        delivery_date: deliveryDate,
      },
    },
  );
  return response.data;
};
